export default "__VITE_ASSET__DPir$Yec__"